import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[cvClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  @Output() readonly cvClickOutside: EventEmitter<void> = new EventEmitter<void>();

  constructor(private readonly ref: ElementRef<HTMLElement>) {}

  @HostListener('document:click', ['$event.target']) onClick(targetElement: HTMLElement): void {
    const clickedInside = this.ref.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.cvClickOutside.emit();
    }
  }
}
